// Helper functions to manage modal visibility
export const cleanupModalBackdrop = () => {
  // Remove all modal backdrops and any rogue overlays
  document.querySelectorAll(".modal-backdrop, .quick-sidebar-overlay, .body-overlay").forEach((el) => el.remove());

  // Remove modal-open and sidebar classes and inline styles from body and html
  document.body.classList.remove("modal-open");
  document.documentElement.classList.remove("nav_open", "topbar_open", "quick_sidebar_open");
  document.body.style.removeProperty("overflow");
  document.body.style.removeProperty("padding-right");
};

export const hideModal = (id) => {
  const modal_el = document.querySelector("#" + id);
  if (modal_el && window.bootstrap?.Modal) {
    const modal_obj = window.bootstrap.Modal.getInstance(modal_el);
    if (modal_obj) {
      modal_obj.hide();
    }
  }

  // Fallback cleanup in case Bootstrap fails to clean up backdrop
  setTimeout(() => {
    if (!document.querySelector(".modal.show")) {
      cleanupModalBackdrop();
    }
  }, 300);
};

// export const showModal = (id)=> {
//   const modal_el = document.querySelector("#" + id);
//   let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

//   if (modal_obj == null) {
//     modal_obj = new window.bootstrap.Modal(modal_el, {
//       backdrop: "static",
//     });
//   }

//   modal_obj.show();
// }

export const showModal = (id) => {
  const modal_el = document.querySelector("#" + id);

  if (!modal_el) {
    console.warn(`Modal element with id "${id}" not found.`);
    return;
  }

  let modal_obj = window.bootstrap.Modal.getInstance(modal_el);

  if (modal_obj == null) {
    modal_obj = new window.bootstrap.Modal(modal_el, {
      backdrop: "static",
    });
  }

  modal_obj.show();
};
